@let isLoading = !!(isLoading$ | async);

<div
  class="md:container md:mx-auto md:w-2/3 mt-4.5"
  [formGroup]="commonFormGroup"
>
  <div class="w-full columns-1 gap-4 px-2">
    <x-request-form-common-main
      [tuiSkeleton]="isLoading"
      [ngClass]="{ 'rounded-(--tui-radius-l)': isLoading }"
      [readOnly]="true"
      class="inline-block box-border w-full h-max mb-4"
    ></x-request-form-common-main>
    <x-request-form-common-lessee
      [tuiSkeleton]="isLoading"
      [ngClass]="{ 'rounded-(--tui-radius-l)': isLoading }"
      [readOnly]="true"
      class="inline-block box-border w-full h-max mb-4"
    ></x-request-form-common-lessee>
    <x-request-form-common-managers
      [tuiSkeleton]="isLoading"
      [ngClass]="{ 'rounded-(--tui-radius-l)': isLoading }"
      [readOnly]="true"
      class="inline-block box-border w-full h-max mb-4"
    ></x-request-form-common-managers>
    <x-request-form-common-logists
      [tuiSkeleton]="isLoading"
      [ngClass]="{ 'rounded-(--tui-radius-l)': isLoading }"
      [readOnly]="true"
      class="inline-block box-border w-full h-max mb-4"
    ></x-request-form-common-logists>
    <x-request-form-common-additional-data
      [tuiSkeleton]="isLoading"
      [ngClass]="{ 'rounded-(--tui-radius-l)': isLoading }"
      [readOnly]="true"
      class="inline-block box-border w-full h-max mb-4"
    ></x-request-form-common-additional-data>
    <x-request-form-common-car
      [tuiSkeleton]="isLoading"
      [ngClass]="{ 'rounded-(--tui-radius-l)': isLoading }"
      [readOnly]="true"
      class="inline-block box-border w-full h-max mb-4"
    >
    </x-request-form-common-car>
    <x-request-form-common-contract
      [tuiSkeleton]="isLoading"
      [ngClass]="{ 'rounded-(--tui-radius-l)': isLoading }"
      [readOnly]="true"
      class="inline-block box-border w-full h-max mb-4"
    >
    </x-request-form-common-contract>
    <x-request-form-common-supplier
      [tuiSkeleton]="isLoading"
      [ngClass]="{ 'rounded-(--tui-radius-l)': isLoading }"
      [readOnly]="true"
      class="inline-block box-border w-full h-max mb-4"
    ></x-request-form-common-supplier>
  </div>
</div>
